import * as React from 'react';
import Stack from '@mui/material/Stack';
import { styled, useThemeProps } from '@mui/material/styles';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Stack": Stack, "@mui/material/styles": { styled, useThemeProps } } } });
export default ClientProvider;
